module.exports = __webpack_public_path__ + "static/hotel5-75ae152759ca0439e334ea5b8333d9f8.jpg";